import React from 'react'
import Img from 'gatsby-image'
import Title from '../../shared/title'
import MDText from '../../shared/MDText'
import Link from 'gatsby-link'

const CourseCard = ({ image, value, text, index, ...props }) => {
  return (
    <div {...props}>
      <Link to={'/learning-outcomes-and-course-content'}>
        <div
          className="card"
          style={{
            width: '25vw',
            padding: '1.5rem',
            background: 'white',
            marginTop: getMarginTop(index),
          }}
        >
          <Img sizes={image.sizes} style={{ margin: '-1.5rem -1.5rem 0' }} />
          <div style={{ margin: '1rem 0' }}>
            <Title title={value} style={{ fontSize: '16px' }} />
          </div>
          <div
            style={{
              fontSize: '12px',
              lineHeight: 1.5,
              marginBottom: '-.45rem',
            }}
          >
            <MDText source={text.internal.content} />
          </div>
        </div>
      </Link>
    </div>
  )
}

export default CourseCard

const getMarginTop = index => {
  switch (index) {
    case 0:
      return 0
    case 1:
      return '4rem'
    case 2:
      return '1.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/homepage/courseValues/courseCard.js